// extracted by mini-css-extract-plugin
export default {"image_wrapper":"image_wrapper___JAi14","gradient":"gradient___xZWje"};